
import Vue from 'vue';
import {
    HAS_ASSESSMENTS,
    HAS_DOCUMENTS,
    HAS_MASTERCLASSES,
    HAS_MY_PROFILE,
    HAS_VFAIRS,
    SHOW_COMPANIES,
    SHOW_JOBS,
    SHOW_PROFILE_BANNER,
} from '~/router';
import { User } from '~/services/IdentityService';
import URLS from '~/URLS';
import { homePage } from '~/router';

// Types
import { Location, RawLocation } from 'vue-router';

// Components
import LocaleDropdown from './LocaleDropdown.vue';
import SchoolVerificationIndicator from './SchoolVerificationIndicator.vue';
import NavigationDropdown, { NavDropdownItem } from './NavigationDropdown.vue';
import NavLink from './NavLink.vue';
import ProfileNavigation from './ProfileNavigation.vue';
import Avatar from '~/components/builders/Avatar.vue';

// Assets
import HigheredLogo from '~/assets/img/HigheredLogo.svg';
import HigheredLogoWhite from '~/assets/img/HigheredLogoWhite.svg';

export default Vue.extend({
    name: 'Navigation',
    components: {
        Avatar,
        SchoolVerificationIndicator,
        LocaleDropdown,
        NavLink,
        NavigationDropdown,
        ProfileNavigation,
    },
    props: {
        value: Boolean,
        vFairMode: Boolean,
    },
    data() {
        return {
            shadow: window.scrollY > 0,
            dropdownTop: 0,

            showProfileNav: false,
            showProfileBanner: SHOW_PROFILE_BANNER,

            urlMatches: {
                jobMatches: [URLS.findjobs, URLS.jobDetail],
                eventMatches: [URLS.vfairs, URLS.vfair],
                resourceMatches: [
                    URLS.masterclasses,
                    URLS.resources,
                    URLS.assessments,
                    // URLS.coursera,
                    URLS.calendar,
                    URLS.account,
                    URLS.favorites,
                ],
            },

            homePage: {
                name: homePage.name,
            } as RawLocation,

            unreadMessageCount: null as string | null,
        };
    },
    computed: {
        urls(): Record<string, string | null> {
            const urls: typeof URLS = (this as any).$URLS;
            const v = (cond: boolean, url: string) => (!cond ? null : url);

            return {
                myProfile: v(HAS_MY_PROFILE, urls.spotlight),
                findJobs: v(SHOW_JOBS, urls.findjobs),
                companies: v(SHOW_COMPANIES, urls.findcompanies),
                events: v(HAS_VFAIRS, urls.vfairs),
                chat: v(true, urls.chat),

                masterclasses: v(HAS_MASTERCLASSES, urls.masterclasses),
                resources: v(HAS_DOCUMENTS, urls.resources),
                assessments: v(HAS_ASSESSMENTS, urls.assessments.concat(urls.assessmentCenter)),
                calendar: v(true, urls.calendar.concat(urls.book)),
                // upskill: v(HAS_COURSERA, urls.coursera),
                cvReview: v(true, 'https://gethighered.com/'),
                blog: v(true, 'https://gethighered.com/blog/'),

                vFairModeMyProfile: 'vfair-profile',
                vFairEventLobby: 'vfair',
            };
        },
        vfairNavLinks(): { to: string | Location | null; label: string; exact?: boolean }[] {
            return [
                {
                    to: this.urls.events,
                    label: this.$t(
                        'components.navigation.navigation.vfairMode.backToAllEvents'
                    ).toString(),
                    exact: true,
                },
                {
                    to: {
                        name: 'vfair-profile',
                    },
                    label: this.$t(
                        'components.navigation.navigation.vfairMode.updateMyProfile'
                    ).toString(),
                },
                {
                    to: {
                        name: 'vfairdetails',
                    },
                    label: this.$t(
                        'components.navigation.navigation.vfairMode.eventLobby'
                    ).toString(),
                },
            ];
        },
        dropdownItems(): NavDropdownItem[] {
            const t = (id: string) => this.$t(`components.navigation.navigation.${id}`) as string;
            return [
                {
                    to: this.urls.masterclasses,
                    label: t('masterclasses'),
                    info: t('info.masterclasses'),
                    icon: ['fal', 'video-plus'],
                    exact: true,
                },
                {
                    to: this.urls.resources,
                    label: t('resources'),
                    info: t('info.resources'),
                    icon: ['fal', 'file'],
                },
                // {
                //     to: this.urls.assessments,
                //     label: t('assessments'),
                //     info: t('info.assessments'),
                //     icon: ['fal', 'list-check'],
                // },
                {
                    to: this.urls.blog,
                    label: t('blog'),
                    info: t('info.blog'),
                    icon: ['fal', 'blog'],
                    external: true,
                },
            ];
        },

        isAuthenticated(): boolean {
            return (this as any).$interfaces.logInModule.isLoggedIn();
        },
        user(): User | null {
            return this.$store.getters['profileModule/getUser']();
        },
        firstLetterInName(): string {
            return this.user ? this.user.firstLetterInName : '';
        },
        hasVFairs(): boolean {
            return this.$interfaces.vfairModule.getHasVFairs(HAS_VFAIRS);
        },
        higheredLogo(): string {
            return this.vFairMode ? HigheredLogoWhite : HigheredLogo;
        },
    },
    methods: {
        handleToggleSidebar() {
            this.$emit('input', !this.$props.value);
        },
        handleScroll() {
            this.shadow = window.scrollY > 0;
        },
        async onUnreadMessagesCountChanged(unreadMessagesCount: number | null) {
            if (unreadMessagesCount) {
                this.unreadMessageCount =
                    unreadMessagesCount > 9 ? '9+' : unreadMessagesCount.toString();
                return;
            }
            this.unreadMessageCount = null;
        },
    },
    mounted() {
        const el = this.$refs['wrapper'] as Element;
        if (Array.isArray(el)) return;

        this.dropdownTop = el.getBoundingClientRect().height;

        window.addEventListener('scroll', this.handleScroll);

        this.$interfaces.vfairModule.setHasVFairs(true);

        this.onUnreadMessagesCountChanged(
            this.$store.getters['talkSessionModule/getUnreadMessagesCount']()
        );
        this.$store.watch(
            () => this.$store.getters['talkSessionModule/getUnreadMessagesCount'](),
            newVal => this.onUnreadMessagesCountChanged(newVal as number | null)
        );
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
});
